import React from 'react';
import { Swiper } from "swiper/react/swiper"
import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper";
import { SwiperSlide } from 'swiper/react/swiper-slide';

import TestimonialItem from './TestimonialItem';

import client from '../assets/img/client.png';

const items = [
    {
        msg: "Shafnas has developed our business website in the best way, He had developed the website within the promised time. we are pleased with the design and layouts of the website.",
        image: client
    },

    {
        msg: "We hired Shafnas to develop a business website for our company, He has done awesome work by developing an attractive and high accessible website more than we expected. I recommend him for any kind of web development project. Am sure he'll do the best.",
        image: client
    },

    {
        msg: "Extraordinary professional! it was a great time to work with Shafnas. He has provided the best service. We are happy to work with him.",
        image: client
    },

    {
        msg: "Shafnas is an excellent web developer. He went above and beyond to meet our requirements and is always trying to deliver a better product.",
        image: client
    }
];
const Testimonial = () => {
    return (
        <section className="testimonial section" id="testimonial">
            <h2 className='section__title'>Testimonial</h2>
            <span className='section__subtitle'>What clients say about me</span>

            <div className='testimonial__container container'>
                <div>
                    <Swiper
                        cssMode={true}
                        navigation={true}
                        pagination={true}
                        mousewheel={true}
                        keyboard={true}
                        modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                        className="mySwiper"
                    >
                        {
                            items.map((item, id) => (
                                <SwiperSlide key={id} ><TestimonialItem value={item} /></SwiperSlide>
                            ))
                        }
                    </Swiper>
                </div>
            </div>
        </section>
    )
    
}

export default Testimonial;